import React from 'react';
import FilterField from './FilterField';
import DateSearchField from './DateSearchField';
import { FilterIcon, FilterButton, FilterText } from './SearchStyles';
import filter from '../../../img/svg/ico-filter.svg';
import ReactTooltip from 'react-tooltip';
import TourTooltip from '../../shared/TourTooltip';
import {
  RequestsFilterCard,
  RequestsFilterForm,
  RequestsSearchFieldGroup,
  RequestsDateFieldGroup,
  RequestsFilterInlineActions
} from './searchFilterToolbar.styles';

const SearchGroup = ({
  setFilter,
  endDate,
  startDate,
  filterDate,
  hiddenInputFilter,
  trailingActions
}) => {
  const onFormSubmit = e => {
    e.preventDefault();
    filterDate();
  };

  return (
    <RequestsFilterCard className="box-search">
      <RequestsFilterForm onSubmit={onFormSubmit}>
        {!hiddenInputFilter && (
          <RequestsSearchFieldGroup>
            <FilterIcon src={filter} alt="" />
            <FilterField
              type="text"
              placeholder="Filtrar id, endereço, pretendente e CPF/CNPJ..."
              submitSearch={setFilter}
              noIcon={true}
            />
            <TourTooltip
              target="tooltip-input-pesquisar-pretendente"
              style={{ right: -10, top: 5 }}
            />
            <ReactTooltip
              id="tooltip-input-pesquisar-pretendente"
              place="top"
              type="dark"
              effect="float"
            >
              Neste campo você pode pesquisar o pretendente analisado.
            </ReactTooltip>
          </RequestsSearchFieldGroup>
        )}

        <RequestsDateFieldGroup>
          <FilterIcon src={filter} alt="" style={{ marginRight: '2px' }} />
          <FilterText style={{ fontWeight: 600, fontSize: '13px' }}>De</FilterText>
          <DateSearchField
            type="text"
            placeholder="dd/mm/aaaa"
            submitSearch={startDate}
          />
          <FilterText style={{ fontWeight: 600, fontSize: '13px' }}>a</FilterText>
          <DateSearchField
            type="text"
            placeholder="dd/mm/aaaa"
            submitSearch={endDate}
          />
          <FilterButton type="submit">Filtrar</FilterButton>
          {trailingActions ? (
            <RequestsFilterInlineActions>
              {trailingActions}
            </RequestsFilterInlineActions>
          ) : null}
        </RequestsDateFieldGroup>
      </RequestsFilterForm>
    </RequestsFilterCard>
  );
};

export default SearchGroup;
